import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarTimes, faMusic } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

interface NoClassesMessageProps {
  selectedDate: Date;
}

const NoClassesMessage: React.FC<NoClassesMessageProps> = ({ selectedDate }) => {
  const formatDate = (date: Date): string => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(today.getDate() + 2);

    const isToday = date.toDateString() === today.toDateString();
    const isTomorrow = date.toDateString() === tomorrow.toDateString();
    const isDayAfterTomorrow = date.toDateString() === dayAfterTomorrow.toDateString();

    if (isToday) return 'today';
    if (isTomorrow) return 'tomorrow';
    if (isDayAfterTomorrow) return 'day after tomorrow';

    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="no-classes-container">
      <div className="no-classes-icon">
        <FontAwesomeIcon icon={faCalendarTimes} />
      </div>
      <div className="no-classes-title">
        No Classes Available
      </div>
      <div className="no-classes-message">
        There are no dance classes scheduled for {formatDate(selectedDate)}.
      </div>
      <div className="no-classes-suggestion">
        <FontAwesomeIcon icon={faMusic} className="suggestion-icon" />
        <span>Try selecting a different date or check out our events!</span>
      </div>
    </div>
  );
};

export default NoClassesMessage; 
